import { httpClient } from '../httpClient';
import {
  IProjectScript,
  CreateProjectScriptRequest,
  UpdateProjectScriptRequest,
  ReorderProjectScriptsRequest
} from '@packages/global';

/**
 * 剧本章节 API 模块
 * 处理剧本章节的 CRUD 操作
 */
export class ProjectScriptApi {

  /**
   * 获取剧本章节列表
   */
  async list(projectId: string): Promise<IProjectScript[]> {
    return httpClient.get<IProjectScript[]>(`/user/project-scripts?projectId=${projectId}`);
  }

  /**
   * 创建剧本章节
   */
  async create(data: CreateProjectScriptRequest): Promise<IProjectScript> {
    return httpClient.post<IProjectScript>('/user/project-scripts', data);
  }

  /**
   * 更新剧本章节
   */
  async update(id: string, data: UpdateProjectScriptRequest): Promise<IProjectScript> {
    return httpClient.put<IProjectScript>(`/user/project-scripts/${id}`, data);
  }

  /**
   * 删除剧本章节
   */
  async delete(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/project-scripts/${id}`);
  }

  /**
   * 批量更新排序
   */
  async reorder(data: ReorderProjectScriptsRequest): Promise<void> {
    return httpClient.post<void>('/user/project-scripts/reorder', data);
  }
}

// 导出单例实例
export const projectScriptApi = new ProjectScriptApi();
